import { setStoreTypeValues } from "utils/setStoreTypeValues";

let types: any = {
  GET_HMO_AWV_REQUEST: "",
  GET_HMO_AWV_SUCCESS: "",
  GET_HMO_AWV_FAILURE: "",

  GET_HMO_METRICS_REQUEST: "",
  GET_HMO_METRICS_SUCCESS: "",
  GET_HMO_METRICS_FAILURE: "",

  GET_MEMBER_MPI_REQUEST: "",
  GET_MEMBER_MPI_SUCCESS: "",
  GET_MEMBER_MPI_FAILURE: "",

  UPDATE_HMO_METRICS_REQUEST: "",
  UPDATE_HMO_METRICS_SUCCESS: "",
  UPDATE_HMO_METRICS_FAILURE: "",

  REFRESH_MEMBER_AWV_STATUS_REQUEST: "",
  REFRESH_MEMBER_AWV_STATUS_SUCCESS: "",
  REFRESH_MEMBER_AWV_STATUS_FAILURE: "",

  DOWNLOAD_MEMBER_PAFS_REQUEST: "",
  DOWNLOAD_MEMBER_PAFS_SUCCESS: "",
  DOWNLOAD_MEMBER_PAFS_FAILURE: "",

  MEMBER_STATUS_EXCEL_REQUEST: "",
  MEMBER_STATUS_EXCEL_SUCCESS: "",
  MEMBER_STATUS_EXCEL_FAILURE: "",

  MEMBER_STATUS_PDF_REQUEST: "",
  MEMBER_STATUS_PDF_SUCCESS: "",
  MEMBER_STATUS_PDF_FAILURE: "",
};

types = setStoreTypeValues(types, "hmo");

export default types;
